import "@/asset/css/index.css";
import ba_bg from "@/asset/img/ba_bg.png";
// mobile
import app_bg from "@/asset/img/jzxs/app_bgv2.png";
import app_tip from "@/asset/img/jzxs/app_tipv2.png";
import app_tel from "@/asset/img/jzxs/app_telv2.png";
// import app_btn from "@/asset/img/dongcheng/app_btnv2.png";

import React from "react";

function MobileIndex() {
  return (
    <div className="app">
      <div className="app-bg">
        <img src={app_bg} alt="xyapp" />
      </div>
      <div className="app-tip animate__animated animate__bounceInDown">
        <img src={app_tip} alt="xyapp" />
      </div>
      <div className="app-tel animate__animated animate__backInDown animate__delay-05s">
        <img src={app_tel} alt="xyapp" />
      </div>
      {/* <div
        className="app-btn animate__animated animate__jello animate__delay-1s"
        onClick={() => toDownUrl()}
      >
        <img src={app_btn} alt="xyapp" />
      </div> */}
      <div className="app-copy">
        <span>©2025 海南墨语网络科技有限公司版权所有</span>
        <br />
        <span className="icp">
          {/* <span>{records}</span> */}
          <img src={ba_bg} alt="ba" className="ba" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style={{ textDecoration: 'none', color: '#999' }}>琼ICP备2024035610号</a>
        </span>
      </div>
    </div>
  )
}

export default MobileIndex;
